export { default } from './Loading'


// WEBPACK FOOTER //
// ./src/components/Loading/index.js